// @flow
import React, { Fragment } from 'react'
import styled, { css } from 'styled-components'
import { Input, Radio } from 'antd'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import { mediaMin } from 'frontend_core/dist/styles/media'
import Colors from 'components/styles/colors'
import Button from 'components/atoms/Button'
import LinkText from 'components/atoms/LinkText'
import Icon from 'components/atoms/Icon'
import SelectItem from 'components/atoms/SelectItem'
import InputContainer from 'components/molecules/InputContainer'
import FormItem from 'components/molecules/FormItem'
import RadioList from 'components/molecules/RadioList'
import FormSectionTitle from 'components/molecules/FormSectionTitle'
import PartsContainer from 'components/molecules/PartsContainer'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { clearFix } from 'components/styles/helpers'

const SubSection = styled.div`
  margin-top: ${spacing.medium_2}px;
  border-top: 1px solid ${Colors.grayE};
`
const PayMethodItem = styled.div`
  padding: ${spacing.medium__15}px 0;
  ${mediaMin.phone`
    padding: ${spacing.medium_2}px 0;
  `} :not(:first-of-type) {
    border-top: 1px solid ${Colors.grayE};
  }

  ${({ isBorder }) =>
    isBorder &&
    css`
      border-top: 1px solid ${Colors.grayE};
    `};
`
const PayMethodItemContent = styled.div`
  padding-top: ${spacing.medium__15}px;
  margin-top: ${spacing.medium__15}px;
  border-top: 1px dashed ${Colors.grayE};
  ${mediaMin.phone`
    padding-top: ${spacing.medium_2}px;
    margin-top: ${spacing.medium}px;
    margin-top: ${spacing.medium_2}px;
  `};
`
const GuideText = styled.pre`
  color: ${Colors.gray9};
  font-size: ${fontSize.small_2}px;
  line-height: 1.27;
  white-space: pre-wrap;
`
const Desc = styled.span`
  display: inline-block;
  margin-left: ${spacing.medium_2}px;
  color: ${Colors.gray9};
  font-size: ${fontSize.small}px;
`
const InputPointText = styled.p`
  color: ${Colors.gray9};
  font-size: ${fontSize.small_3}px;
`
const InputPointSupplementText = styled.p`
  font-size: ${fontSize.small_2}px;

  :not(:first-of-type) {
    margin-top: ${spacing.small_2}px;
  }
`
const InputPointSupplementTextWrapper = styled.div`
  margin-top: ${spacing.medium_2}px;
`
const InputPointApplicationContaier = styled.div`
  ${mediaMin.phone`
    display: table;
    table-layout: fixed;
    width: 100%;
    max-width: 420px;
  `};
`
const InputPointApplication = styled.div`
  ${mediaMin.phone`
    display: table-cell;
    width: 100%;
    padding-right: ${spacing.small_2}px;
    vertical-align: top;
  `};
`
const InputPointApplicationButton = styled.div`
  margin-top: ${spacing.medium}px;
  ${mediaMin.phone`
    display: table-cell;
    width: 120px;
    margin-top: 0;
    vertical-align: top;
  `};
`
const FormItemWrapper = styled.div`
  margin-top: ${spacing.small_3}px;
  ${mediaMin.phone`
    margin-top: ${spacing.medium}px;
  `};
`
const AvailableAllPointLinkText = styled.p`
  margin-top: ${spacing.small_3}px;
  text-align: center;
  ${mediaMin.phone`
    text-align: left;
  `};
`
const AvailablePointText = styled.p`
  display: inline-block;
  font-size: ${fontSize.small_3}px;
  font-weight: bold;
`
const AvailablePointLinkText = styled.p`
  display: inline-block;
  margin-left: ${spacing.small_3}px;
  float: right;
  ${mediaMin.phone`
    float: none;
  `};
`
const AvailablePointTextContainer = styled.div`
  margin-top: ${spacing.medium__15}px;
  ${clearFix()};
  ${({ show }) =>
    show
      ? css`
          display: block;
        `
      : css`
          display: none;
        `} ${mediaMin.phone`
      margin-top: ${spacing.medium_2}px;
    `};
`

export type PropTypes = {
  availablepoint: string,
  holdPoint: string,
  availablePointLately: string,
  showPoint: boolean,
  showCoupon: boolean,
  applyPoint: string,
  disabledPoint: boolean,
  disabledCoupon: boolean,
  discountMethod: number,
  onChangeDisCountMethod: Function,
  onClickApplyAllPoint: Function,
  onClickRemovePoint: Function,
}

export default function PointCouponSection(props: PropTypes) {
  const RadioGroup = Radio.Group
  return (
    <div>
      <FormSectionTitle
        title={i18n.t(
          'page.dashboard.reservation.selectPayMethod.usePointCoupon',
        )}
        description={i18n.t(
          'page.dashboard.reservation.selectPayMethod.usePointCouponGuide',
        )}
        required
      />
      <SubSection>
        <RadioGroup
          value={props.discountMethod}
          onChange={e => props.onChangeDiscountMethod(e.target.value)}
        >
          <PayMethodItem>
            <Radio value={1}>
              {i18n.t('page.dashboard.reservation.selectPayMethod.unUse')}
            </Radio>
          </PayMethodItem>
          <PayMethodItem>
            <Radio value={2}>
              {i18n.t('page.dashboard.reservation.selectPayMethod.point')}
              <Desc>
                {i18n.t(
                  'page.dashboard.reservation.selectPayMethod.availablePoint',
                  {
                    point: props.availablepoint,
                  },
                )}
              </Desc>
            </Radio>
            {props.discountMethod === 2 && (
              <PayMethodItemContent>
                <InputPointText>
                  {i18n.t(
                    'page.dashboard.reservation.selectPayMethod.inputUsePoint',
                  )}
                </InputPointText>
                <InputPointSupplementTextWrapper>
                  <InputPointSupplementText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.holdPoint',
                    )}
                    ：{props.holdPoint}
                  </InputPointSupplementText>
                  <InputPointSupplementText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.availablePointLately',
                    )}
                    ：{props.availablePointLately}
                  </InputPointSupplementText>
                </InputPointSupplementTextWrapper>
                <FormItemWrapper>
                  <FormItem
                    renderInput={() => (
                      <InputPointApplicationContaier>
                        <InputPointApplication>
                          <InputContainer>
                            <Input
                              size="large"
                              placeholder="000"
                              type="number"
                              disabled={props.disabledPoint > 0}
                              value={props.usePoint}
                              onChange={e =>
                                props.onChangeUsePoint(e.target.value)
                              }
                            />
                          </InputContainer>
                        </InputPointApplication>
                        <InputPointApplicationButton>
                          <Button
                            tag="button"
                            buttonType="medium"
                            colorType="blue"
                            fullWidthSp
                            fullWidthPc
                            disabled={props.disabledPoint > 0}
                            onClick={props.onClickApplyPoint}
                          >
                            {i18n.t('page.shared.apply')}
                          </Button>
                        </InputPointApplicationButton>
                      </InputPointApplicationContaier>
                    )}
                    errorTexts={props.usePointErrors}
                  />
                </FormItemWrapper>
                <AvailableAllPointLinkText>
                  <LinkText
                    onClick={e => {
                      e.preventDefault()
                      props.onClickApplyAllPoint()
                    }}
                  >
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.applyAvailableAllPoint',
                    )}
                  </LinkText>
                </AvailableAllPointLinkText>
                <AvailablePointTextContainer show={props.showPoint}>
                  <AvailablePointText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.applyPoint',
                      { point: props.applyPoint },
                    )}
                  </AvailablePointText>
                  <AvailablePointLinkText>
                    <LinkText
                      onClick={e => {
                        e.preventDefault()
                        props.onClickRemovePoint()
                      }}
                    >
                      <Icon className="fa fa-times" positionType="left" />
                      {i18n.t('page.shared.absolve')}
                    </LinkText>
                  </AvailablePointLinkText>
                </AvailablePointTextContainer>
              </PayMethodItemContent>
            )}
          </PayMethodItem>
          <PayMethodItem>
            <Radio value={3}>
              {i18n.t('page.dashboard.reservation.selectPayMethod.coupon')}
            </Radio>
            {props.discountMethod === 3 && (
              <PayMethodItemContent>
                <GuideText>
                  {i18n.t(
                    'page.dashboard.reservation.selectPayMethod.inputCouponCodeGuide',
                  )}
                </GuideText>
                <FormItemWrapper>
                  <FormItem
                    renderInput={() => (
                      <InputPointApplicationContaier>
                        <InputPointApplication>
                          <Input
                            size="large"
                            placeholder={i18n.t(
                              'page.dashboard.reservation.selectPayMethod.inputCouponCode',
                            )}
                            disabled={props.disabledCoupon}
                            value={props.couponCode}
                            onChange={e =>
                              props.onChangeCouponCode(e.target.value)
                            }
                          />
                        </InputPointApplication>
                        <InputPointApplicationButton>
                          <Button
                            tag="button"
                            buttonType="medium"
                            colorType="blue"
                            fullWidthSp
                            fullWidthPc
                            disabled={props.disabledCoupon}
                            onClick={props.onClickApplyCoupon}
                          >
                            {i18n.t('page.shared.apply')}
                          </Button>
                        </InputPointApplicationButton>
                      </InputPointApplicationContaier>
                    )}
                    errorTexts={props.couponErrors}
                  />
                  <AvailablePointTextContainer show={props.showCoupon}>
                    <AvailablePointText>
                      {props.couponCode}
                      {i18n.t(
                        'page.dashboard.reservation.selectPayMethod.applyCoupon',
                      )}
                    </AvailablePointText>
                    <AvailablePointLinkText>
                      <LinkText
                        onClick={e => {
                          e.preventDefault()
                          props.onClickRemoveCoupon()
                        }}
                      >
                        <Icon className="fa fa-times" positionType="left" />
                        {i18n.t('page.shared.absolve')}
                      </LinkText>
                    </AvailablePointLinkText>
                  </AvailablePointTextContainer>
                </FormItemWrapper>
              </PayMethodItemContent>
            )}
          </PayMethodItem>
        </RadioGroup>
      </SubSection>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/organisms/PointCouponSection/index.jsx